document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  // A normal link should always leave on the first click. Some app/browser
  // combinations can cancel the first event while hydrating theme controls;
  // only fall back to native navigation when no drawer opened and the URL has
  // genuinely remained unchanged. Modifier keys, external links and special
  // protocols retain their standard browser behaviour.
  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

    const link = event.target.closest('a[href]');
    if (!link || link.target || link.hasAttribute('download')) return;

    const rawHref = link.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#') || /^(mailto:|tel:|javascript:)/i.test(rawHref)) return;

    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin) return;

    // The editorial brand-story cards sit inside a heavily animated layout.
    // On some browsers that layout cancels the anchor's native first click
    // while finishing its pointer interaction. Take ownership of these plain
    // internal text links so one click always starts navigation immediately.
    if (link.closest('.brand-story__copy')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(destination.href);
      return;
    }

    const startingUrl = window.location.href;
    window.setTimeout(() => {
      const overlayOpened = document.body.classList.contains('open-cc') ||
        document.body.classList.contains('overflow-hidden');
      if (!overlayOpened && window.location.href === startingUrl) {
        window.location.assign(destination.href);
      }
    }, 260);
  }, true);

  document.querySelectorAll('[data-food-finder]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const data = new FormData(form);
      const terms = [
        data.get('pet'),
        data.get('life_stage'),
        data.get('food_type'),
        data.get('need')
      ].filter(Boolean);

      const query = encodeURIComponent(terms.join(' '));
      window.location.href = `/search?q=${query}&type=product&options%5Bprefix%5D=last`;
    });
  });

  document.querySelectorAll('[data-rail]').forEach((rail) => {
    const viewport = rail.querySelector('[data-rail-viewport]');
    if (!viewport) return;

    const currentLabel = rail.querySelector('[data-rail-current]');
    const totalLabel = rail.querySelector('[data-rail-total]');
    const previousButton = rail.querySelector('[data-rail-direction="previous"]');
    const nextButton = rail.querySelector('[data-rail-direction="next"]');
    let totalPages = 1;

    const updateRailPosition = () => {
      const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      totalPages = Math.max(1, Math.ceil(viewport.scrollWidth / viewport.clientWidth));
      rail.classList.toggle('rail--single-page', totalPages <= 1);
      const progress = maxScroll > 0 ? viewport.scrollLeft / maxScroll : 0;
      const currentPage = Math.min(totalPages, Math.max(1, Math.round(progress * (totalPages - 1)) + 1));

      if (currentLabel) currentLabel.textContent = String(currentPage);
      if (totalLabel) totalLabel.textContent = String(totalPages);
      if (previousButton) previousButton.disabled = currentPage <= 1;
      if (nextButton) nextButton.disabled = currentPage >= totalPages;
    };

    rail.querySelectorAll('[data-rail-direction]').forEach((button) => {
      button.addEventListener('click', () => {
        const direction = button.dataset.railDirection === 'next' ? 1 : -1;
        viewport.scrollBy({ left: viewport.clientWidth * 0.92 * direction, behavior: 'smooth' });
      });
    });

    viewport.addEventListener('scroll', updateRailPosition, { passive: true });
    window.addEventListener('resize', updateRailPosition);
    updateRailPosition();
  });
});
